module.exports = __webpack_public_path__ + "static/media/how-it-works-image-2-2.0de62ec7.png";